import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Box,
  Card,
  CardContent,
  Collapse,
  IconButton,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/form-provider';
import RHFTextArea from 'src/components/hook-form/rhf-text-area';
import { useMyDataStore } from 'src/store/me/me.store';

type Props = {
  methods: any;
  onSubmit: VoidFunction;
  isEdit: boolean;
  isSubmitting: boolean;
};

function SectionTitle() {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          color: 'common.white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
        }}
      >
        1
      </Box>
      <Typography variant="h6" fontWeight={700}>
        Informações
      </Typography>
    </Stack>
  );
}

export default function CategoryForm({ methods, onSubmit, isEdit, isSubmitting }: Props) {
  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.benefits);
  const [expanded, setExpanded] = useState(true);

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Stack spacing={3}>
        <Controller
          name="status"
          control={methods.control}
          render={({ field }) => (
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={1}
              sx={{ p: 1 }}
            >
              <Typography variant="subtitle1" fontWeight={600}>
                {field.value === 'active' ? 'Ativo' : 'Inativo'}
              </Typography>
              <Switch
                checked={field.value === 'active'}
                onChange={(_, checked) => field.onChange(checked ? 'active' : 'inactive')}
              />
            </Stack>
          )}
        />

        <Card>
          <CardContent>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ mb: 1 }}
            >
              <SectionTitle />
              <IconButton onClick={() => setExpanded((current) => !current)}>
                {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </Stack>

            <Collapse in={expanded} timeout="auto" unmountOnExit={false}>
              <Stack spacing={2} sx={{ pt: 1 }}>
                <RHFTextField name="name" label="Nome" variant="filled" />
                <RHFTextArea name="description" label="Descrição" variant="filled" />
              </Stack>
            </Collapse>
          </CardContent>
        </Card>

        <Stack alignItems="flex-end">
          <LoadingButton
            type="submit"
            variant="contained"
            loading={isSubmitting}
            disabled={(isEdit && !permissions?.update) || (!isEdit && !permissions?.create)}
          >
            {!isEdit ? 'Cadastrar Categoria' : 'Editar Categoria'}
          </LoadingButton>
        </Stack>
      </Stack>
    </FormProvider>
  );
}
